import { useEffect } from 'react';

export function useAppsflyerBanner(): void {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    if (document.getElementById('appsflyer-smart-banner')) {
      return;
    }

    const script = document.createElement('script');

    script.id = 'appsflyer-smart-banner';
    script.innerHTML = `
      !function(t,e,n,s,a,c,i,o,p){
        t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
          (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))
        },
        t.AF.id=t.AF.id||i,t.AF.plugins={},
        o=e.createElement(n),
        p=e.getElementsByTagName(n)[0],
        o.async=1,
        o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
        p.parentNode.insertBefore(o,p)
      }(window,document,"script",0,"AF","banners",{banners: {key: "f60ce706-1106-4ee0-96b8-4a6b59845038"}});
      AF('banners', 'showBanner');
    `;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const s = document.getElementById('appsflyer-smart-banner');

      if (s) {
        s.remove();
      }
    };
  }, []);
}
